<script>
export default {
  name: 'VatTooltip',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    id="js__product__vat-tooltip"
    class="app__product__vat-tooltip"
    data-nosnippet
  >
    <span
      v-html="content"
    />
  </div>
</template>

<style lang="scss" scoped>
.app__product__vat-tooltip {
  font-size: $font-size-small;

  :deep(table) {
    font-size: $font-size-small;
  }
}
</style>
